module.exports = __webpack_public_path__ + "static/media/ico1.55f5d70c.svg";